/// <reference path="jquery.min.js" />
/// <reference path="jquery.datetimepicker.full.js" />
/// <reference path="jquery.tooltipster.js" />
/* Funktion zum lesefreundlichen Umrechnen der erlaubten Dateigröße */
function bytesToSize(bytes) {
    "use strict";
    var i, sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) {
        return '0 Byte';
    }
    i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}
/* Funktion zum Setzen */
function setFileupload(field) {
    "use strict";
    var element = $(field),
        inputval = element.val();

    if (inputval !== "") {
        inputval = inputval.replace("C:\\fakepath\\", "");
        element.parent().find(".js-form-fileinput").text(inputval);
    } else {
        element.parent().find(".js-form-fileinput").text("");
    }
}
/* Funktion zum Ermitteln der IE Version (bis IE9 möglich) */
function checkIE(param) {
    "use strict";
    var version = false;
    $('<div id="check-ie" style="display:none"><!--[if lte IE 9]><span id="lte-9"></span><![endif]--><!--[if lte IE 8]><span id="lte-8"></span><![endif]--><!--[if lte IE 7]><span id="lte-7"></span><![endif]--></div>').appendTo("body");
    if (param !== undefined && $("#lte-" + param).length) {
        $("#check-ie").remove();
        return true;
    }
    if (param === undefined) {
        if ($("#lte-9").length) {
            version = 9;
        }
        if ($("#lte-8").length) {
            version = 8;
        }
        if ($("#lte-7").length) {
            version = 7;
        }
    }
    $("#check-ie").remove();
    return version;
}
/* Funktion um Handler dynamisch hinzufügen */
function addHandler(name, value, action, target) {
    "use strict";
    var el,
        elcontainer,
        field = $(".form-general [name='" + name + "']");

    if ($("#" + target).length) {
        el = $("#" + target);
        elcontainer = el.closest("div.form-col");

        if (action === "show") {
            elcontainer.addClass("display-none");
        }

        field.on("change", function () {
            var element = $(this),
                elementval = "";

            if (element.is(":checkbox")) {
                element.closest(".form-group").find(":checked").each(function () {
                    elementval += $(this).val() + "|";
                });
            } else if (element.hasClass("js-form-part")) {
                element.closest(".js-form-group").find(".js-form-part").each(function () {
                    elementval += $(this).val() + ".";
                });
                elementval = elementval.slice(0, -1);
            } else {
                elementval = element.val();
            }

            if (element.is(":checked") || element.is("select") || element.is("input:text")) {
                if (elementval !== "" && ((elementval === value || value.indexOf(elementval + "|") > -1 || elementval.indexOf(value + "|") > -1) || (value.indexOf("^") === 0 && new RegExp(value, "i").test(elementval)))) {
                    if (action === "show") {
                        elcontainer.removeClass("display-none");
                    } else {
                        elcontainer.addClass("display-none");
                        if(!elcontainer.hasClass('js-not-reset-on-hide')){
                            elcontainer.find("input:checked").prop("checked", false).trigger("change").end()
                                .find("input[type='text']:not([readonly]), input[type='number']:not([readonly]), input[type='tel']:not([readonly])").val("").trigger("change").end()
                                .find("option:selected").prop("selected", false).trigger("change").end()
                                .find(".tooltipstered.form-error").tooltipster("hide");
                        }
                    }
                } else {
                    if (action === "show") {
                        elcontainer.addClass("display-none");
                        if(!elcontainer.hasClass('js-not-reset-on-hide')){
                            elcontainer.find("input:checked").prop("checked", false).trigger("change").end()
                                .find("input[type='text']:not([readonly]), input[type='number']:not([readonly]), input[type='tel']:not([readonly])").val("").trigger("change").end()
                                .find("option:selected").prop("selected", false).trigger("change").end()
                                .find(".tooltipstered.form-error").tooltipster("hide");
                        }
                    } else {
                        elcontainer.removeClass("display-none");
                    }
                }
            } else if (elementval.indexOf(value + "|") < 0) {
                if (action === "show") {
                    elcontainer.addClass("display-none").find("input:checked").prop("checked", false).trigger("change").end()
                        .find("input[type='text']:not([readonly]), input[type='number']:not([readonly]), input[type='tel']:not([readonly])").val("").trigger("change").end()
                        .find("option:selected").prop("selected", false).trigger("change").end()
                        .find(".tooltipstered.form-error").tooltipster("hide");
                } else {
                    elcontainer.removeClass("display-none");
                }
            }
        });
    }
}
/* Funktion zur Prüfung auf korrekte JSON Struktur */
function tryParseJSON(jsonString) {
    "use strict";
    try {
        var o = JSON.parse(jsonString);

        if (o && typeof o === "object" && o !== null) {
            return o;
        }
    } catch (ignore) { }

    return false;
}

/* Wenn Formular vorhanden, dann Code ausführen */
var form, formTrigger, current_locale, pageLanguage, getGroups, formProgress, formActiveClass, formDoneClass;
function validateAllForms(parent) {
    //$(".tooltipstered").tooltipster('destroy');
    
    if ($().validate && $(".form-general").length) {        
        $(function () {
            "use strict";
            //var form, formTrigger, pageLanguage, getGroups, formProgress, formActiveClass, formDoneClass;
            if(parent !== undefined){
                //parent.find(".tooltipstered").tooltipster('destroy');  // 20.06.2021: sollte nicht benötigt werden.
                form = parent.find(".form-general");
            }else{
                form = $(".form-general");
            }
            
            form.find(".form-nopaste").on("paste", function (e) {
                e.preventDefault();
            });
            pageLanguage = $('html')[0].lang;

            // current locale
            current_locale = $('body').data('current-locale');

            /* Mehrseitige Formulare */
            if (form.find(".form-fieldset").length) {
                // Unterteilung der Fieldsets in Seiten
                form.find(".form-fieldset").slice(1).addClass("display-none");
                // Anzeige Vor und Zurück Button
                form.find(".form-page-next, .form-page-back").removeClass("display-none");
                form.find(".form-fieldset:first .form-page-back").addClass("display-none");
                form.find(".form-fieldset:last .form-page-next").addClass("display-none");
                // Fortschrittsanzeige
                formProgress = $(".form-progress");
                formActiveClass = formProgress.attr("data-class-active");
                formDoneClass = formProgress.attr("data-class-done");
                if (formActiveClass === undefined) {
                    formActiveClass = "active";
                }
                if (formDoneClass === undefined) {
                    formDoneClass = "done";
                }
                formProgress.find(".form-progress-step:first-child").addClass(formActiveClass);
                // Vor und Zurück Blättern
                $(".form-page-next").click(function (e) {

                    if (form.valid()) {

                        var fieldset, pagenum, pageback, sourcejson, sourceparse, fieldId, fieldVal, gotopage;

                        fieldset = $(this).closest(".form-fieldset");
                        pagenum = parseInt(fieldset.attr("data-page"), 10);
                        pageback = pagenum;
                        fieldset.addClass("display-none");
                        pagenum = pagenum + 1;
                        if (fieldset.find(".form-col[data-pagerule]").length) {
                            sourcejson = fieldset.find(".form-col[data-pagerule]").attr("data-pagerule");
                            sourceparse = $.parseJSON(sourcejson);
                            $.each(sourceparse, function (index, value) {
                                fieldId = value.id;
                                fieldVal = value.value;
                                gotopage = value.page;
                                if (form.find("input#" + fieldId).is(":checked") || form.find("select#" + fieldId).val() === fieldVal) {
                                    pagenum = gotopage;
                                }
                            });
                        }
                        form.find(".form-fieldset[data-page='" + pagenum + "'] .form-page-back").attr("data-history", pageback).end().find(".form-fieldset[data-page='" + pagenum + "']").removeClass("display-none");
                        // Trigger Fortschrittsanzeige
                        formProgress.find(".form-progress-step").removeClass(formDoneClass + " " + formActiveClass).end()
                            .find(".form-progress-step:lt(" + (pagenum - 1) + ")").addClass(formDoneClass).end()
                            .find(".form-progress-step:eq(" + (pagenum - 1) + ")").addClass(formActiveClass);
                    }
                    e.preventDefault();
                });
                $(".form-page-back, .form-page-goto").click(function (e) {

                    var fieldset, pagenum;

                    fieldset = $(this).closest(".form-fieldset");
                    pagenum = parseInt($(this).attr("data-history"), 10);
                    fieldset.addClass("display-none");
                    form.find(".form-fieldset[data-page='" + pagenum + "']").removeClass("display-none");
                    // Trigger Fortschrittsanzeige
                    formProgress.find(".form-progress-step").removeClass(formDoneClass + " " + formActiveClass).end()
                        .find(".form-progress-step:lt(" + (pagenum - 1) + ")").addClass(formDoneClass).end()
                        .find(".form-progress-step:eq(" + (pagenum - 1) + ")").addClass(formActiveClass);
                    e.preventDefault();
                });
            }

            /* Feldregeln */
            /*
                {
                    "name":"name attribut des elements",
                    "value":"value bei dessen wahl die aktion durchgeführt wird",
                    "action":"aktion", //werte: show, hide
                    "target":"id des elements, auf das sich die aktion bezieht"
                }
            */
            if (form.find("div.form-group[data-fieldrule]").length) {
                (function () {
                    var i,
                        n,
                        sourcejson,
                        sourceparse,
                        sourceparseLength,
                        field,
                        fieldName,
                        fieldValue,
                        fieldAction,
                        fieldTarget,
                        ruleFieldVal,
                        ruleField = form.find("div.form-group[data-fieldrule]"),
                        ruleFieldLength = ruleField.length;

                    for (i = 0; i < ruleFieldLength; i = i + 1) {
                        sourcejson = $(ruleField[i]).attr("data-fieldrule");
                        sourceparse = tryParseJSON(sourcejson);
                        sourceparseLength = sourceparse.length;

                        for (n = 0; n < sourceparseLength; n = n + 1) {
                            fieldName = sourceparse[n].name;
                            fieldValue = sourceparse[n].value;
                            fieldAction = sourceparse[n].action;
                            fieldTarget = sourceparse[n].target;

                            // Check if rule has multi values and if value is regex
                            if (fieldValue.indexOf("|") > -1 && fieldValue.indexOf("^") !== 0) {
                                fieldValue = fieldValue + "|";
                            }
                            if (form.find("[name='" + fieldName + "']").length) {
                                field = form.find("[name='" + fieldName + "']");
                                ruleFieldVal = "";

                                addHandler(fieldName, fieldValue, fieldAction, fieldTarget);

                                //if (form.find("[name='" + fieldName + "']").is(":checkbox")) {
                                if (field.is(":checkbox")) {
                                    // Triggert onchange bei Pagereload oder Pageback für Checkboxen
                                    field.closest(".form-group").find(":checked").each(function () {
                                        ruleFieldVal += $(this).val() + "|";
                                    });
                                    if (ruleFieldVal !== "" && ruleFieldVal.indexOf(fieldValue) > -1) {
                                        field.trigger("change");
                                    }
                                } else {
                                    if (field.hasClass("js-form-part")) {
                                        // Triggert onchange bei Pagereload oder Pageback für Datumsfelder
                                        field.closest(".js-form-group").find(".js-form-part").each(function () {
                                            ruleFieldVal += $(this).val() + ".";
                                        });
                                        ruleFieldVal = ruleFieldVal.slice(0, -1);
                                    } else {
                                        if (field.is(":radio")) {
                                            // Triggert onchange bei Pagereload oder Pageback für Radio Buttons
                                            field = form.find("input[name='" + fieldName + "']:checked");
                                        } else {
                                            // Triggert onchange bei Pagereload oder Pageback für select und restliche input Felder
                                            field = form.find("[name='" + fieldName + "']");
                                        }
                                        ruleFieldVal = field.val();
                                    }
                                    if (ruleFieldVal !== "" && ((ruleFieldVal === fieldValue || fieldValue.indexOf(ruleFieldVal + "|") > -1) || (fieldValue.indexOf("^") === 0 && new RegExp(fieldValue, "i").test(ruleFieldVal)))) {
                                        field.trigger("change");
                                    }
                                }
                            }
                        }
                    }
                }());
            }

            /* Übergabe Fileupload Value an <label> für die Anzeige */
            if (form.find("input[type='file']").length) {
                form.find("input[type='file']").change(function () {
                    setFileupload($(this));
                }).each(function () {
                    setFileupload($(this));
                });
            }

            /* Add maxlength to type number fields */
            if (form.find("input[max]").length) {
                form.find("input[max]").keyup(function () {
                    var element = $(this),
                        elementval = element.val(),
                        maxval = element.attr("max");

                    if (maxval !== "") {
                        if (elementval.length > maxval.length) {
                            element.val(elementval.slice(0, -1));
                        }
                    }
                });
            }

            /* Add function to show/mask blank password
            if (form.find("input.form-showpassword").length) {
                form.find("input.form-showpassword").prop("checked", false).change(function () {
                    var element = $(this),
                        passwordfield = element.closest(".form-row").find("input[type='password']"),
                        textfield = element.closest(".form-row").find("input.form-transformed");

                    if (passwordfield.length || textfield.length) {
                        if (element.is(":checked")) {
                            passwordfield.attr("type", "text").addClass("form-transformed");
                        } else {
                            textfield.attr("type", "password").removeClass("form-transformed");
                        }
                    }
                });
            }*/

            /* Funktion zum Ermitteln von 'groups' und Übergabe an jQuery validate Aufruf (es gibt folgende 'groups': 1. Datumsfelder, 2. Rufnummer+Durchwahl) */
            getGroups = function () {
                var groupElements, field1Name, field2Name, field3Name, result = {};
                groupElements = form.find(".form-date-day").get();
                $(groupElements).each(function (i) {
                    var elementClosest,
                        element = $(this);

                    elementClosest = element.closest('.form-col');
                    field1Name = elementClosest.find('.form-date-day').attr('name');
                    field2Name = elementClosest.find('.form-date-month').attr('name');
                    field3Name = elementClosest.find('.form-date-year').attr('name');
                    if (field1Name !== undefined && field2Name !== undefined && field3Name !== undefined) {
                        result['dateGroup_' + i] = field1Name + ' ' + field2Name + ' ' + field3Name;
                    }

                });
                return result;
            };

            /* Formular Validierung */
            form.find("input[pattern]").addClass("validate-pattern").end()
                .find(".js-calendar[data-maxdate]").addClass("validate-maxdate").end()
                .find(".js-form-group[data-maxdate]").find(".js-form-part").addClass("validate-maxdate");
            form.find(".js-calendar[data-mindate]").addClass("validate-mindate").end()
                .find(".js-form-group[data-mindate]").find(".js-form-part").addClass("validate-mindate");
            form.find("select.validate-date").on('focusout', function () { /* Validierung der Datumsfelder bei focusout unterbinden */
                return false;
            });

            switch(pageLanguage) {
                case 'de':
                    $.extend($.validator.messages, {
                        required: "Dieses Feld ist ein Pflichtfeld.",
                        maxlength: $.validator.format("Geben Sie bitte maximal {0} Zeichen ein."),
                        minlength: $.validator.format("Geben Sie bitte mindestens {0} Zeichen ein."),
                        rangelength: $.validator.format("Geben Sie bitte mindestens {0} und maximal {1} Zeichen ein."),
                        email: "Geben Sie bitte eine gültige E-Mail Adresse ein.",
                        url: "Geben Sie bitte eine gültige URL ein.",
                        date: "Bitte geben Sie ein gültiges Datum ein.",
                        number: "Geben Sie bitte eine Zahl ein.",
                        digits: "Geben Sie bitte nur Ziffern ein.",
                        equalTo: "Bitte wiederholen Sie den zuvor angegebenen Wert.",
                        range: $.validator.format("Geben Sie bitte einen Wert zwischen {0} und {1} ein."),
                        max: $.validator.format("Geben Sie bitte einen Wert kleiner oder gleich {0} ein."),
                        min: $.validator.format("Geben Sie bitte einen Wert größer oder gleich {0} ein."),
                        iban: "Bitte geben Sie eine gültige IBAN ein.",
                        validdate: "Bitte geben Sie ein gültiges Datum ein."
                    });
                    break;
                case 'fr':
                    $.extend($.validator.messages, {
                        required: "Ce champ est obligatoire.",
                        maxlength: $.validator.format("Veuillez saisir un maximum de {0} caractères."),
                        minlength: $.validator.format("Veuillez entrer au moins {0} caractères."),
                        rangelength: $.validator.format("Veuillez saisir au moins {0} et au plus {1} caractères."),
                        email: "Veuillez saisir une adresse électronique valide.",
                        url: "Veuillez entrer une URL valide.",
                        date: "Veuillez entrer une date valide.",
                        number: "Veuillez entrer un numéro.",
                        digits: "Veuillez saisir uniquement des chiffres.",
                        equalTo: "Veuillez répéter la valeur donnée précédemment.",
                        range: $.validator.format("Veuillez entrer une valeur entre {0} et {1}."),
                        max: $.validator.format("Veuillez entrer une valeur inférieure ou égale à {0}."),
                        min: $.validator.format("Veuillez entrer une valeur supérieure ou égale à {0}."),
                        iban: "Veuillez saisir un IBAN valide.",
                        validdate: "Veuillez entrer une date valide."
                    });
                    break;
                case 'es':
                    $.extend($.validator.messages, {
                        required: "Este campo es obligatorio.",
                        maxlength: $.validator.format("Por favor, introduzca un máximo de {0} caracteres."),
                        minlength: $.validator.format("Por favor, introduzca al menos {0} caracteres."),
                        rangelength: $.validator.format("Por favor, introduzca un mínimo de {0} y un máximo de {1} caracteres."),
                        email: "Por favor, introduzca una dirección de correo electrónico válida.",
                        url: "Por favor, introduzca una URL válida.",
                        date: "Por favor, introduzca una fecha válida.",
                        number: "Por favor, introduzca un número.",
                        digits: "Por favor, introduzca sólo dígitos.",
                        equalTo: "Por favor, repita el valor dado anteriormente.",
                        range: $.validator.format("Por favor, introduzca un valor entre {0} y {1}."),
                        max: $.validator.format("Por favor, introduzca un valor menor o igual a {0}."),
                        min: $.validator.format("Por favor, introduzca un valor mayor o igual a {0}."),
                        iban: "Por favor, introduzca un IBAN válido.",
                        validdate: "Por favor, introduzca una fecha válida."
                    });
                    break;
                case 'it':
                    $.extend($.validator.messages, {
                        required: "Questo campo è obbligatorio.",
                        maxlength: $.validator.format("Si prega di inserire un massimo di {0} caratteri."),
                        minlength: $.validator.format("Inserisci almeno {0} caratteri."),
                        rangelength: $.validator.format("Inserisci almeno {0} e al massimo {1} caratteri."),
                        email: "Inserisci un indirizzo e-mail valido.",
                        url: "Si prega di inserire un URL valido.",
                        date: "Si prega di inserire una data valida.",
                        number: "Si prega di inserire un numero.",
                        digits: "Si prega di inserire solo cifre.",
                        equalTo: "Si prega di ripetere il valore dato prima.",
                        range: $.validator.format("Inserisci un valore tra {0} e {1}."),
                        max: $.validator.format("Inserisci un valore inferiore o uguale a {0}."),
                        min: $.validator.format("Inserisci un valore maggiore o uguale a {0}."),
                        iban: "Si prega di inserire un IBAN valido.",
                        validdate: "Si prega di inserire una data valida."
                    });
                    break;
            }

            $.validator.addMethod('upload', function (value, element) { /* Methode für erlaubte Dateiendungen und Dateigröße */
                // some quick simple tests to prevent needless work
                if (this.optional(element)) {
                    return true;
                }

                var uploadSize, uploadMessage, combinedMessage, sizeConverted, sizeMessage, size, extensionMatch, extensionConverted, extensionMessage, extension = $(element).attr("data-extension"), dimensionMessage, minImageWidth, minImageHeight, dimensionIsOk;  // 18.01.2024 - CT: dimensionMessage, minWidth und minHeight, dimensionIsOk neu

                size = $(element).attr("data-size");
                sizeConverted = bytesToSize(size);
                extensionConverted = extension.replace(/,/g, ", ");
                extension = typeof extension === "string"
                    ? extension.replace(/,/g, "|")
                    : "png|jpe?g|gif";
                extensionMatch = value.match(new RegExp(".(" + extension + ")$", "i"));

                // image dimension validation
                minImageWidth = parseInt($(element).attr("data-min-image-width"), 10);
                minImageHeight = parseInt($(element).attr("data-min-image-height"), 10);
                dimensionIsOk = true;

                if(typeof minImageWidth !== 'undefined' || typeof minImageHeight !== 'undefined'){
                    var image_width = parseInt($(element).attr('data-image-width'), 10);
                    var image_height = parseInt($(element).attr('data-image-height'), 10);

                    if(image_width < minImageWidth || image_height < minImageHeight){
                        dimensionIsOk = false;
                    }
                }
                // image dimension validation end

                if (checkIE(9)) {
                    uploadSize = size;
                } else {
                    if (element.files.length) {
                        uploadSize = element.files[0].size;
                    }
                }

                switch(pageLanguage) {
                    case 'de':
                        sizeMessage = "Bitte wählen Sie eine Datei, die kleiner ist als " + sizeConverted;
                        extensionMessage = "Bitte wählen Sie eine Datei mit einer der folgenden Endungen: " + extensionConverted;
                        dimensionMessage = "Bitte wählen Sie ein Bild mit einer Mindestbreite von " +  minImageWidth + " und Mindesthöhe von " + minImageHeight;
                        combinedMessage = sizeMessage + " und eine der folgenden Dateiendungen hat: " + extensionConverted;
                        break;
                    case 'fr':
                        sizeMessage = "Veuillez choisir un fichier inférieur à " + sizeConverted;
                        extensionMessage = "Veuillez sélectionner un fichier avec l'une des extensions suivantes : " + extensionConverted;
                        dimensionMessage = "Veuillez sélectionner une image avec une largeur minimale de " + minImageWidth + " et une hauteur minimale de " + minImageHeight;
                        combinedMessage = sizeMessage + " et possède l'une des extensions de fichier suivantes : " + extensionConverted;
                        break;
                    case 'es':
                        sizeMessage = "Por favor, elija un archivo de menos de " + sizeConverted;
                        extensionMessage = "Seleccione un archivo con una de las siguientes extensiones: " + extensionConverted;
                        dimensionMessage = "Seleccione una imagen con una anchura mínima de " + minImageWidth + " y una altura mínima de " + minImageHeight;
                        combinedMessage = sizeMessage + " y tiene una de las siguientes extensiones de archivo: " + extensionConverted;
                        break;
                    case 'it':
                        sizeMessage = "Per favore scegli un file più piccolo di " + sizeConverted;
                        extensionMessage = "Seleziona un file con una delle seguenti estensioni: " + extensionConverted;
                        dimensionMessage = "Seleziona un'immagine con una larghezza minima di " + minImageWidth + " e un'altezza minima di " + minImageHeight;
                        combinedMessage = sizeMessage + " e ha una delle seguenti estensioni di file: " + extensionConverted;
                        break;
                    default:
                        sizeMessage = "Please choose a file smaller than " + sizeConverted;
                        extensionMessage = "Please choose one of the following file types: " + extensionConverted;
                        dimensionMessage = "Please select an image with a minimum width of " + minImageWidth + " and minimum height of " + minImageHeight;
                        combinedMessage = sizeMessage + " and with one of the following file extensions: " + extensionConverted;
                        break;
                }

                if (extensionMatch === null && uploadSize > size) {
                    uploadMessage = combinedMessage;
                } else {
                    if (uploadSize > size) {
                        uploadMessage = sizeMessage;
                    }
                    if (extensionMatch === null) {
                        uploadMessage = extensionMessage;
                    }
                }
                if(!dimensionIsOk){
                    uploadMessage = (typeof uploadMessage !== "undefined" ? uploadMessage + " " : "") + dimensionMessage;
                }
                $.extend($.validator.messages, {
                    upload: uploadMessage
                });
                return this.optional(element) || (extensionMatch && uploadSize <= size && dimensionIsOk);
            });
            $.validator.addMethod('pattern', function (value, element) { /* Methode für erlaubte Pattern */
                // some quick simple tests to prevent needless work
                if (this.optional(element)) {
                    return true;
                }

                var patternMessage, patternAddtoMessage, regularExp, patternAttr = $(element).attr("pattern"), posA, posB;

                if (patternAttr !== "" && patternAttr !== null) {
                    regularExp = new RegExp("^" + patternAttr + "$");
                    if (patternAttr.indexOf("[\\S\\s]{") > -1 && patternAttr.indexOf(",}") > -1) { /* Minlength Pattern */
                        patternAddtoMessage = patternAttr.replace(/[^\d.]/g, '');
                        $(element).rules("add", {
                            minlength: patternAddtoMessage
                        });
                        return true;
                    } else if (patternAttr.indexOf("[0-9]{") > -1 && patternAttr.indexOf(",}") > -1) { /* Minlength Pattern only numbers */
                        posA = parseInt(patternAttr.indexOf("{"), 10) + 1;
                        posB = parseInt(patternAttr.indexOf(",}"), 10);
                        patternAddtoMessage = patternAttr.substring(posA, posB);
                        $(element).rules("add", {
                            number: true,
                            minlength: patternAddtoMessage
                        });
                        return true;
                    } else if (patternAttr.indexOf("[A-Za-z0-9äöüÄÖÜß]{") > -1 && patternAttr.indexOf(",}") > -1) { /* Minlength and only numbers and characters */
                        patternMessage = "Geben Sie bitte mind. 5 Zeichen bestehend aus Zahlen und Buchstaben ein.";
                        if (pageLanguage === "en") {
                            patternMessage = "Please enter at least 5 characters, consisting of numbers and letters.";
                        }
                    } else if (patternAttr.match(/[0-9a-zA-Z\-\(\)\/\+\-\s\.#]/)) { /* Phone Pattern */
                        patternMessage = "Geben Sie bitte eine gültige Rufnummer ein.";
                        if (pageLanguage === "en") {
                            patternMessage = "Please enter a correct phone number.";
                        }
                    }
                    $.extend($.validator.messages, {
                        pattern: patternMessage
                    });
                    return value.match(regularExp);
                }
                return true;
            });
            $.validator.addMethod('validdatecallback', function (value, element) { /* Methode für gültiges Datum und Uhrzeit bei Callback */
                // some quick simple tests to prevent needless work
                if (this.optional(element)) {
                    return true;
                }

                var date,
                    dateElement = $(element),
                    dateDay,
                    dateMonth,
                    dateYear,
                    dateTime,
                    minDate,
                    minDateSplit,
                    minTime,
                    maxTime,
                    extendMessage;

                date = value.split(" ");
                dateTime = date[1];
                date = date[0].split(".");
                dateDay = parseInt(date[0], 10).toString();
                if (dateDay.length === 1) {
                    dateDay = "0" + dateDay;
                }
                dateMonth = parseInt(date[1], 10).toString();
                if (dateMonth.length === 1) {
                    dateMonth = "0" + dateMonth;
                }
                dateYear = parseInt(date[2], 10).toString();
                date = new Date(dateYear + '-' + dateMonth + "-" + dateDay + "T" + dateTime);
                if (Object.prototype.toString.call(date) === "[object Date]") {
                    if (isNaN(date) === false) { // it is a date
                        minDate = dateElement.attr("data-mindate");
                        minTime = dateElement.attr("data-mintime");
                        maxTime = dateElement.attr("data-maxtime");
                        if (minDate.indexOf("/") > -1) {
                            minDateSplit = minDate.split("/");
                        }
                        if (minDate.indexOf(".") > -1) {
                            minDateSplit = minDate.split(".");
                        }
                        minDate = new Date(minDateSplit[2], minDateSplit[1] - 1, minDateSplit[0]);
                        // check if date is higher than mindate
                        if (date < minDate) {
                            minDate.setDate(minDate.getDate() - 1);
                            minDate = minDate.getDate() + "." + (minDate.getMonth() + 1) + "." + minDate.getFullYear();
                            extendMessage = "Bitte geben Sie ein Datum nach dem " + minDate + " ein.";
                            if (pageLanguage === "en") {
                                extendMessage = "Please enter a date after " + minDate + ".";
                            }
                            $.extend($.validator.messages, {
                                validdatecallback: extendMessage
                            });
                            return false;
                        }
                        // check if time is between min and max time
                        if (dateTime > maxTime || dateTime < minTime) {
                            extendMessage = "Bitte wählen Sie eine Uhrzeit zwischen " + minTime + " und " + maxTime + " Uhr.";
                            if (pageLanguage === "en") {
                                extendMessage = "Please pick a time between " + minTime + " and " + maxTime + " o'clock.";
                            }
                            $.extend($.validator.messages, {
                                validdatecallback: extendMessage
                            });
                            return false;
                        }
                        // check if day is not sunday
                        if (date.getDay() === 0) {
                            extendMessage = "Bitte wählen Sie einen Termin von Montag bis Samstag.";
                            if (pageLanguage === "en") {
                                extendMessage = "Please pick a date between Monday and Saturday.";
                            }
                            $.extend($.validator.messages, {
                                validdatecallback: extendMessage
                            });
                            return false;
                        }
                        return true;
                    }
                }
                return false;
            });
            $.validator.addMethod('validdate', function (value, element) { /* Methode für gültiges Datum */
                // some quick simple tests to prevent needless work
                if (this.optional(element)) {
                    return true;
                }

                var date,
                    dateElement = $(element),
                    parentElement = dateElement.closest(".js-form-group"),
                    dateDay,
                    dateMonth,
                    dateYear,
                    dateTime;


                if (dateElement.hasClass("js-form-part")) { /* Methode für Dropdowns */
                    dateDay = parseInt(parentElement.find("select.form-date-day").val(), 10);
                    dateMonth = parseInt(parentElement.find("select.form-date-month").val(), 10) - 1;
                    dateYear = parseInt(parentElement.find("select.form-date-year").val(), 10);

                    if (parentElement.find("select[required]").length) {
                        if (parentElement.find("select.form-date-day").hasClass("display-none") && isNaN(dateMonth) === false && isNaN(dateYear) === false) {
                            dateDay = 1;
                        }
                        date = new Date(dateYear, dateMonth, dateDay);
                        if (isNaN(dateDay) === false && isNaN(dateMonth) === false && isNaN(dateYear) === false && date.getFullYear() === dateYear && date.getMonth() === dateMonth && date.getDate() === dateDay) {
                            return true;
                        }
                    } else {
                        if (parentElement.find("select.form-date-day").hasClass("display-none") && isNaN(dateMonth) && isNaN(dateYear)) {
                            dateDay = NaN;
                        }
                        date = new Date(dateYear, dateMonth, dateDay);
                        if ((isNaN(dateDay) && isNaN(dateMonth) && isNaN(dateYear)) || (date.getFullYear() === dateYear && date.getMonth() === dateMonth && date.getDate() === dateDay)) {
                            return true;
                        }
                    }
                } else { /* Methode für Date(time)picker */
                    if (value !== "") {
                        if (dateElement.hasClass("form-date-calendartime")) {
                            date = value.split(" ");
                            dateTime = date[1];
                            date = date[0].split(".");
                        } else {
                            date = value.split(".");
                        }
                        dateDay = parseInt(date[0], 10).toString();
                        if (dateDay.length === 1) {
                            dateDay = "0" + dateDay;
                        }
                        dateMonth = parseInt(date[1], 10).toString();
                        if (dateMonth.length === 1) {
                            dateMonth = "0" + dateMonth;
                        }
                        dateYear = parseInt(date[2], 10).toString();
                        if (dateElement.hasClass("form-date-calendartime")) {
                            date = new Date(dateYear + '-' + dateMonth + "-" + dateDay + "T" + dateTime);
                        } else {
                            date = new Date(dateYear, dateMonth, dateDay);
                        }
                        if (Object.prototype.toString.call(date) === "[object Date]") {
                            if (isNaN(date) === false) { // it is a date
                                return true;
                            }
                        }
                    } else {
                        return true;
                    }
                }
                return false;
            });
            $.validator.addMethod('maxdate', function (value, element) { /* Methode für max. Datum */
                // some quick simple tests to prevent needless work
                if (this.optional(element)) {
                    return true;
                }

                var maxdate, maxDateSplit, maxdateDay, maxdateMonth, maxdateYear, maxdateMessage, date, dateDay, dateMonth, dateYear, dataField = $(element);

                if (dataField.hasClass("js-form-part")) {
                    dataField = dataField.closest(".js-form-group");
                }
                maxdate = dataField.attr("data-maxdate");
                if (maxdate.indexOf("/") > -1) {
                    maxDateSplit = maxdate.split("/");
                }
                if (maxdate.indexOf(".") > -1) {
                    maxDateSplit = maxdate.split(".");
                }
                maxdateDay = parseInt(maxdate[0], 10);
                maxdateMonth = parseInt(maxdate[1], 10) - 1;
                maxdateYear = parseInt(maxdate[2], 10);
                maxdate = new Date(maxdateYear, maxdateMonth, maxdateDay);

                if (dataField.hasClass("js-form-group")) { /* Methode für Dropdowns */
                    dateDay = parseInt(dataField.find(".form-date-day").val(), 10);
                    if (dataField.find(".form-date-day").is(":visible") === false) {
                        dateDay = maxdateDay;
                    }
                    dateMonth = parseInt(dataField.find(".form-date-month").val(), 10) - 1;
                    dateYear = parseInt(dataField.find(".form-date-year").val(), 10);
                } else { /* Methode für Date(time)picker */
                    date = value.split(".");
                    dateDay = parseInt(date[0], 10).toString();
                    if (dateDay.length === 1) {
                        dateDay = "0" + dateDay;
                    }
                    dateMonth = parseInt(date[1], 10) - 1;
                    dateMonth = dateMonth.toString();
                    if (dateMonth.length === 1) {
                        dateMonth = "0" + dateMonth;
                    }
                    dateYear = parseInt(date[2], 10).toString();
                }
                date = new Date(dateYear, dateMonth, dateDay);

                if (isNaN(dateDay) === false && isNaN(dateMonth) === false && isNaN(dateYear) === false && isNaN(maxdateDay) === false && isNaN(maxdateMonth) === false && isNaN(maxdateYear) === false) {
                    if (date > maxdate) {
                        maxdate.setDate(maxdate.getDate() + 1);
                        maxdate = (maxdate.getDate()) + "." + (maxdate.getMonth() + 1) + "." + maxdate.getFullYear();
                        maxdateMessage = "Bitte geben Sie ein Datum vor dem " + maxdate + " ein.";
                        if (pageLanguage === "en") {
                            maxdateMessage = "Please enter a date before " + maxdate + ".";
                        }
                        $.extend($.validator.messages, {
                            maxdate: maxdateMessage
                        });
                        return false;
                    }
                }
                return true;
            });
            $.validator.addMethod('mindate', function (value, element) { /* Methode für min. Datum */
                // some quick simple tests to prevent needless work
                if (this.optional(element)) {
                    return true;
                }

                var mindate, minDateSplit, mindateDay, mindateMonth, mindateYear, mindateMessage, date, dateDay, dateMonth, dateYear, dataField = $(element);

                if (dataField.hasClass("js-form-part")) {
                    dataField = dataField.closest(".js-form-group");
                }
                mindate = dataField.attr("data-mindate");
                if (mindate.indexOf("/") > -1) {
                    minDateSplit = mindate.split("/");
                }
                if (mindate.indexOf(".") > -1) {
                    minDateSplit = mindate.split(".");
                }
                
                mindateDay = parseInt(minDateSplit[0], 10);
                mindateMonth = parseInt(minDateSplit[1], 10) - 1;
                mindateYear = parseInt(minDateSplit[2], 10);
                mindate = new Date(mindateYear, mindateMonth, mindateDay);

                if (dataField.hasClass("js-form-group")) { /* Methode für Dropdowns */
                    dateDay = parseInt(dataField.find(".form-date-day").val(), 10);
                    if (dataField.find(".form-date-day").is(":visible") === false) {
                        dateDay = mindateDay;
                    }
                    dateMonth = parseInt(dataField.find(".form-date-month").val(), 10) - 1;
                    dateYear = parseInt(dataField.find(".form-date-year").val(), 10);
                } else { /* Methode für Date(time)picker */
                    date = value.split(".");
                    dateDay = parseInt(date[0], 10).toString();
                    if (dateDay.length === 1) {
                        dateDay = "0" + dateDay;
                    }
                    dateMonth = parseInt(date[1], 10) - 1;
                    dateMonth = dateMonth.toString();
                    if (dateMonth.length === 1) {
                        dateMonth = "0" + dateMonth;
                    }
                    dateYear = parseInt(date[2], 10).toString();
                }
                date = new Date(dateYear, dateMonth, dateDay);

                if (isNaN(dateDay) === false && isNaN(dateMonth) === false && isNaN(dateYear) === false) {
                    if (date < mindate) {
                        mindate.setDate(mindate.getDate() - 1);
                        mindate = (mindate.getDate()) + "." + (mindate.getMonth() + 1) + "." + mindate.getFullYear();
                        mindateMessage = "Bitte geben Sie ein Datum nach dem " + mindate + " ein.";
                        if (pageLanguage === "en") {
                            mindateMessage = "Please enter a date after " + mindate + ".";
                        }
                        $.extend($.validator.messages, {
                            mindate: mindateMessage
                        });
                        return false;
                    }
                }
                return true;
            });
            $.validator.addMethod("iban", function (value, element) {
                /**
                 * IBAN is the international bank account number.
                 * It has a country - specific format, that is checked here too
                 */
                // some quick simple tests to prevent needless work
                if (this.optional(element)) {
                    return true;
                }

                // remove spaces and to upper case
                var iban = value.replace(/ /g, "").toUpperCase(),
                    ibancheckdigits = "",
                    leadingZeroes = true,
                    cRest = "",
                    cOperator = "",
                    countrycode,
                    ibancheck,
                    charAt,
                    cChar,
                    bbanpattern,
                    bbancountrypatterns,
                    ibanregexp,
                    i,
                    p;

                // check the country code and find the country specific format
                countrycode = iban.substring(0, 2);
                bbancountrypatterns = {
                    "AT": "\\d{16}"
                };

                // bbanpattern = bbancountrypatterns[countrycode];
                // Nur österr. Pattern erlauben
                bbanpattern = bbancountrypatterns["AT"];
                // As new countries will start using IBAN in the
                // future, we only check if the countrycode is known.
                // This prevents false negatives, while almost all
                // false positives introduced by this, will be caught
                // by the checksum validation below anyway.
                // Strict checking should return FALSE for unknown
                // countries.
                if (bbanpattern !== undefined) {
                    //ibanregexp = new RegExp("^[A-Z]{2}\\d{2}" + bbanpattern + "$", "");
                    // Nur auf österr. IBAN überprüfen
                    ibanregexp = new RegExp("^" + countrycode + "\\d{2}" + bbanpattern + "$", "");
                    if (!(ibanregexp.test(iban))) {
                        return false; // invalid country specific format
                    }
                }

                // now check the checksum, first convert to digits
                ibancheck = iban.substring(4, iban.length) + iban.substring(0, 4);
                for (i = 0; i < ibancheck.length; i = i + 1) {
                    charAt = ibancheck.charAt(i);
                    if (charAt !== "0") {
                        leadingZeroes = false;
                    }
                    if (!leadingZeroes) {
                        ibancheckdigits += "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ".indexOf(charAt);
                    }
                }

                // calculate the result of: ibancheckdigits % 97
                for (p = 0; p < ibancheckdigits.length; p = p + 1) {
                    cChar = ibancheckdigits.charAt(p);
                    cOperator = "" + cRest + "" + cChar;
                    cRest = cOperator % 97;
                }
                return cRest === 1;
            });
            $.validator.methods.number = function (value, element) {
                // some quick simple tests to prevent needless work
                if (this.optional(element)) {
                    return true;
                }

                if ($(element).hasClass("validate-integer")) {
                    $.extend($.validator.messages, {
                        number: "Bitte geben Sie eine abgerundete Zahl ohne Punkt und Komma ein."
                    });
                    if ((value.indexOf(",") > -1 || value.indexOf(".") > -1) && (/^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:[\.\,]\d+)?$/).test(value.replace(/,/g, "").replace(/\./g, ""))) {
                        return false;
                    }
                }
                if ($(element).hasClass("validate-float")) {
                    return /^-?(?:\d+|\d{1,3}(?:\.\d{3})+)(?:,\d+)?$/.test(value);
                }
                return /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:[\.\,]\d+)?$/.test(value);
            };
            $.validator.addClassRules("validate-upload", {
                upload: true
            });
            $.validator.addClassRules("validate-pattern", {
                pattern: true
            });
            $.validator.addClassRules("validate-date-callback", {
                validdatecallback: true
            });
            $.validator.addClassRules("validate-date", {
                validdate: true
            });
            $.validator.addClassRules("validate-maxdate", {
                maxdate: true
            });
            $.validator.addClassRules("validate-mindate", {
                mindate: true
            });
            $.validator.addClassRules("validate-iban", {
                iban: true
            });



            if (form.is("form")) {

                formTrigger = form;
            } else {

                formTrigger = form.closest("form");
            }
            $(formTrigger).each(function () {
                $(this).validate({
                    groups: getGroups(),
                    validClass: "form-valid",
                    errorClass: "form-error",
                    errorElement: "span",
                    errorPlacement: function (error, element) {
                        if (element.hasClass("js-form-part")) {
                            error.appendTo(element.closest(".js-form-group"));
                        } else {
                            error.appendTo(element.closest(".form-group"));
                        }
                    },
                    highlight: function (element, errorClass, validClass) {
                        var field = $(element);
                        if (field.hasClass("js-form-part")) {
                            field.closest(".js-form-group").find(".js-form-part").removeClass(validClass).addClass(errorClass).closest(".form-group").removeClass(validClass).addClass(errorClass);
                            setTimeout(function () {
                                if (field.hasClass("js-form-part")) {
                                    field.closest(".js-tooltip-formerror").tooltipster('content', field.closest(".js-form-group").find("span.form-error").text()).tooltipster("show");
                                } else {
                                    field.tooltipster("content", field.closest(".form-group").find("span.form-error").text()).tooltipster("show");
                                }
                            }, 100);
                        } else {
                            field.removeClass(validClass).addClass(errorClass).closest(".form-group").removeClass(validClass).addClass(errorClass);
                            setTimeout(function () {
                                field.tooltipster("content", field.closest(".form-group").find("span.form-error").text()).tooltipster("show");
                            }, 100);
                        }
                    },
                    unhighlight: function (element, errorClass, validClass) {
                        var field = $(element);
                        if (field.hasClass("js-form-part")) {
                            field.closest(".js-form-group").find(".js-form-part").removeClass(errorClass).addClass(validClass).closest(".form-group").removeClass(errorClass).addClass(validClass).end()
                                .closest(".js-tooltip-formerror").tooltipster("hide");
                        } else {
                            field.removeClass(errorClass).addClass(validClass).closest(".form-group").removeClass(errorClass).addClass(validClass).end()
                                .tooltipster("hide");
                        }
                    },
                    submitHandler: function () {
                        return true;
                    }
                });
            });

            /* Initiate tooltipster and assign to all existing tooltips */
            if ($().tooltipster) {
                // Trigger error Tooltip on form fields
                if ($(".form-general .form-control:not(.tooltipstered), .js-tooltip-formerror:not(.tooltipstered)").length) {
                    $(".form-general .form-control:not(.tooltipstered), .js-tooltip-formerror:not(.tooltipstered)").tooltipster({
                        functionBefore: function (origin, continueTooltip) {
                            var tooltip = $(origin);

                            continueTooltip();

                            if (tooltip.hasClass("js-form-group")) {
                                tooltip.tooltipster("option", "offsetY", "-10px");
                            }
                            if (tooltip.closest(".fancybox-content").length) {
                                $(".tooltipster-red").css("z-index", "8030");
                            }
                        },
                        trigger: "custom",
                        delay: 200,
                        maxWidth: 380,
                        theme: "tooltipster-red",
                        position: "bottom",
                        speed: 200,
                        updateAnimation: false
                    });
                }
                $("body").on("inview", ".form-general .form-control:not(.tooltipstered), .js-tooltip-formerror:not(.tooltipstered)", function () {
                    $(this).tooltipster({
                        functionBefore: function (origin, continueTooltip) {
                            var tooltip = $(origin);

                            continueTooltip();

                            if (tooltip.hasClass("js-form-group")) {
                                tooltip.tooltipster("option", "offsetY", "-10px");
                            }
                            if (tooltip.closest(".fancybox-content").length) {
                                $(".tooltipster-red").css("z-index", "8030");
                            }
                        },
                        trigger: "custom",
                        delay: 200,
                        maxWidth: 380,
                        theme: "tooltipster-red",
                        position: "bottom",
                        speed: 200,
                        updateAnimation: false
                    });
                });
            }

            var country_date_format = $('select#Land option:selected').attr('data-language-locale');
            var datepicker_settings = {
                //format: country_date_format,
                language: country_date_format,
                //weekStart: pageLanguage == 'en' ? 0 : 1,   // nicht notwendig, passiert in locale files
                //maxViewMode: '2 years',
                disableTouchKeyboard: true,
                //startDate: '-1d',
                clearBtn: true,
                calendarWeeks: true,
                autoclose: true,
                todayHighlight: true,
                todayBtn: true
            };
            var datepicker = $('.custom-datepicker').datepicker(datepicker_settings);

            if($('.custom-datepicker').closest('form').find('select#Land').length){
                $('.custom-datepicker').closest('form').find('select#Land').on('change', function(){
                    var country_date_format = $('select#Land option:selected').attr('data-language-locale');
                    var current_chosen_date = $('.custom-datepicker').datepicker('getUTCDate');

                    datepicker.datepicker('remove');
                    datepicker_settings['language'] = country_date_format;  // https://en.wikipedia.org/wiki/Date_format_by_country
                    $('.custom-datepicker').datepicker(datepicker_settings);
                    $('.custom-datepicker').datepicker('setUTCDate', current_chosen_date); // "now" für heute
                });
            }
        
            datepicker.on('changeDate', function(selected) {
                // console.log("Datum geändert!");
                // var selected_date = new Date(selected.date.valueOf());
                // console.log("selected_date: ", selected_date);
            });
        
            datepicker.on('clearDate', function(e) {
                // console.log("Datum gelöscht!");
            });


            /* DateTimePicker Implementierung */
            /*
            jQuery.datetimepicker.setLocale('de');
            if ($().datetimepicker && form.find(".js-calendar").length) {
                (function () {
                    var i,
                        element = form.find(".js-calendar"),
                        elementlength = element.length,
                        currentYear = new Date().getFullYear(),
                        picker,
                        pickeryearstart,
                        pickeryearend,
                        pickermindate,
                        pickermaxdate,
                        pickerallowtimes,
                        pickersplit;

                    for (i = 0; i < elementlength; i = i + 1) {
                        picker = $(element[i]);
                        pickeryearstart = currentYear - 80;
                        pickeryearend = currentYear + 20;
                        pickermindate = false;
                        pickermaxdate = false;
                        pickerallowtimes = [
                            '00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00',
                            '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'
                        ];

                        if (picker.attr("data-maxdate") !== undefined) {
                            pickermaxdate = picker.attr("data-maxdate");
                            pickersplit = pickermaxdate.split("/");
                            pickeryearend = new Date(pickersplit[2], pickersplit[1] - 1, pickersplit[0]).getFullYear();
                        }
                        if (picker.attr("data-mindate") !== undefined) {
                            pickermindate = picker.attr("data-mindate");
                            pickersplit = pickermindate.split("/");
                            pickeryearstart = new Date(pickersplit[2], pickersplit[1] - 1, pickersplit[0]).getFullYear();
                        }
                        if (picker.attr("data-allowtimes") !== undefined) {
                            pickerallowtimes = picker.attr("data-allowtimes").split(',');
                        }
                        if (picker.hasClass("form-date-calendartime")) {
                            if (picker.attr("data-mindate") !== undefined) {
                                pickermindate = new Date(pickersplit[2], pickersplit[1] - 1, pickersplit[0]);
                                pickermindate.setDate(pickermindate.getDate());
                                pickermindate = pickermindate.getDate() + "." + (pickermindate.getMonth() + 1) + "." + pickermindate.getFullYear();
                            }
                            picker.datetimepicker({ // Datum und Uhrzeit
                                format: 'd.m.Y H:i',
                                formatDate: 'd.m.Y',
                                formatTime: 'H:i',
                                step: 30,
                                lazyInit: true,
                                timepicker: true,
                                lang: pageLanguage,
                                yearStart: pickeryearstart,
                                yearEnd: pickeryearend,
                                minDate: pickermindate,
                                maxDate: pickermaxdate,
                                startDate: pickermindate,
                                allowTimes: pickerallowtimes,
                                dayOfWeekStart: 1,
                                inline: false,
                                className: 'xdsoft_with_timepicker',
                                onGenerate: function () {
                                    $('.xdsoft_with_timepicker').find('.xdsoft_day_of_week0').addClass('xdsoft_disabled');
                                },
                                onShow: function (current_time, $input) {
                                    if ($input.val() === '') {
                                        this.setOptions({
                                            startDate: false
                                        });
                                    }
                                },
                                onSelectTime: function (current_time, $input) {
                                    $input.blur();
                                }
                            });
                        } else {
                            picker.datetimepicker({ // Datum
                                i18n:{
                                    de:{
                                    months:[
                                    'Januar','Februar','März','April',
                                    'Mai','Juni','Juli','August',
                                    'September','Oktober','November','Dezember',
                                    ],
                                    dayOfWeek:[
                                    "So.", "Mo", "Di", "Mi", 
                                    "Do", "Fr", "Sa.",
                                    ]
                                    }
                                },
                                format: 'd.m.Y',
                                formatDate: 'd.m.Y',
                                lazyInit: true,
                                timepicker: false,
                                yearStart: pickeryearstart,
                                yearEnd: pickeryearend,
                                minDate: pickermindate,
                                maxDate: pickermaxdate,
                                startDate: pickermaxdate,
                                dayOfWeekStart: 1,
                                inline: false,
                                onSelectDate: function (current, $input) {
                                    $input.blur();
                                }
                            });
                        }
                    }
                }());
            }
            */
        });
    }
}

validateAllForms();